import { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "@phosphor-icons/react";
import api, { formatApiErrorDetail } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
    } catch (err) {}
    setSent(true);
    setLoading(false);
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-background px-4">
      <div className="w-full max-w-md animate-fade-in-up">
        <div className="bg-card border border-border rounded-lg p-8">
          <h2 className="font-heading text-xl mb-1">Şifre sıfırlama</h2>
          {sent ? (
            <p className="text-sm text-muted-foreground mt-3" data-testid="forgot-confirmation">
              Eğer bu e-posta kayıtlıysa, bir sıfırlama bağlantısı gönderildi. Gelen kutunuzu kontrol edin.
            </p>
          ) : (
            <>
              <p className="text-sm text-muted-foreground mb-6">
                E-posta adresinizi girin, size sıfırlama bağlantısı gönderelim.
              </p>
              <form onSubmit={submit} className="space-y-4">
                <div>
                  <Label htmlFor="email" className="text-xs uppercase tracking-wide text-muted-foreground">E-posta</Label>
                  <Input id="email" type="email" required data-testid="forgot-email" value={email}
                    onChange={(e) => setEmail(e.target.value)} className="mt-1.5 bg-secondary border-border" />
                </div>
                <Button type="submit" disabled={loading} data-testid="forgot-submit"
                  className="w-full bg-primary text-primary-foreground hover:bg-primary/90 font-medium">
                  {loading ? "Gönderiliyor..." : "Bağlantı Gönder"}
                </Button>
              </form>
            </>
          )}
          <Link to="/login" data-testid="back-to-login" className="mt-6 inline-flex items-center gap-1.5 text-sm text-primary hover:underline">
            <ArrowLeft size={16} /> Girişe dön
          </Link>
        </div>
      </div>
    </div>
  );
}
